/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { ReactComponent as DollarIcon } from '../../../../assets/svg/company-icon/dollor.svg';

const CompanyRevenue = props => {
  const { revenue = '', parentClass = '', clsName = '' } = props;

  return revenue !== undefined && revenue !== '' && revenue !== null ? (
    <div className={`company-revenue icon-wrap ${parentClass}`}>
      <DollarIcon className="svg-icon" />
      <div className={`item-name show-elipsis ${clsName}`} title={revenue}>
        {revenue}
      </div>
    </div>
  ) : (
    ''
  );
};

export { CompanyRevenue };
export default CompanyRevenue;
